import { FlexActionValidation } from '../models/transaction-action.model'

/**
 * Read a 400 body as a Flex Transactions validation array (`[{validationId, message}]`) — the shape
 * both the actions endpoint and the save endpoint (helios !518) reject with.
 *
 * Accepts the array itself and a JSON string wrapping it — `HttpClient` leaves the body as text
 * when the response carries no JSON content type, which a hand-rolled error response easily does.
 *
 * Moved out of the workbench grid (PVAL-26440) so the grid's action messages and the dialogs' save
 * messages read a rejection by one rule.
 *
 * @param body the error body
 * @returns the validations found, or an empty array when the body is something else
 */
export function readValidations(body: unknown): FlexActionValidation[] {
  let source = body
  if (typeof source === 'string') {
    const text = source.trim()
    if (!text.startsWith('[')) return []
    try {
      source = JSON.parse(text)
    } catch {
      return []
    }
  }
  if (!Array.isArray(source)) return []
  return source.filter(
    (entry): entry is FlexActionValidation =>
      !!entry &&
      typeof entry === 'object' &&
      typeof (entry as FlexActionValidation).validationId === 'string',
  )
}
